import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { userService, type UserProfile } from '../../services/userService';
import type { ApiResponse } from '../menu/types';
import { mediaProbeApi } from '../media/api/mediaProbeApi';
import { ProfilePhotoEditor } from '../profile-photo/ProfilePhotoEditor';
import type { DetailFormJsMethodProps } from './registry';

export const SelfProfilePhotoJsMethodBinding = ({ onNotify }: DetailFormJsMethodProps) => {
  const dispatch = useDispatch();
  const [user, setUser] = useState<Pick<UserProfile, 'Id' | 'Initials'> | null>(null);

  useEffect(() => {
    let mounted = true;

    userService
      .getCurrentUser()
      .then((response) => {
        if (!mounted) return;
        const payload = response.data as ApiResponse<UserProfile> | UserProfile;
        const userData: UserProfile =
          'data' in payload && payload.data ? payload.data : (payload as UserProfile);
        setUser({ Id: userData.Id, Initials: userData.Initials });
      })
      .catch((error: unknown) => {
        if (!mounted) return;
        const message =
          error instanceof Error ? error.message : 'Failed to load the current user profile.';
        onNotify({ severity: 'error', message });
      });

    return () => {
      mounted = false;
    };
  }, [onNotify]);

  if (!user?.Id) {
    return null;
  }

  return (
    <ProfilePhotoEditor
      relationId={user.Id}
      initials={user.Initials}
      uploadWithRelationId={false}
      onUploaded={() => {
        dispatch(mediaProbeApi.util.invalidateTags([{ type: 'ProfilePhoto', id: user.Id }]));
      }}
      onError={(message) => onNotify({ severity: 'error', message })}
    />
  );
};
